'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTriangleFilled, iconTriangleFilledTag } from '@ni/nimble-components/dist/esm/icons/triangle-filled';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTriangleFilled };
export { iconTriangleFilledTag };
export const NimbleIconTriangleFilled = wrap(IconTriangleFilled);